import { render, staticRenderFns } from "./TreatmentView.vue?vue&type=template&id=7dfd0c30&scoped=true"
import script from "./TreatmentView.vue?vue&type=script&lang=js"
export * from "./TreatmentView.vue?vue&type=script&lang=js"
import style0 from "./TreatmentView.vue?vue&type=style&index=0&id=7dfd0c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd0c30",
  null
  
)

export default component.exports